import { render, staticRenderFns } from "./DeliveryCost.vue?vue&type=template&id=6b732726&scoped=true&"
import script from "./DeliveryCost.vue?vue&type=script&lang=js&"
export * from "./DeliveryCost.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCost.vue?vue&type=style&index=0&id=6b732726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b732726",
  null
  
)

export default component.exports